import { render, staticRenderFns } from "./TCheckbox.vue?vue&type=template&id=7846c085&"
import script from "./TCheckbox.vue?vue&type=script&lang=js&"
export * from "./TCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7846c085')) {
      api.createRecord('7846c085', component.options)
    } else {
      api.reload('7846c085', component.options)
    }
    module.hot.accept("./TCheckbox.vue?vue&type=template&id=7846c085&", function () {
      api.rerender('7846c085', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/TCheckboxGroup/TCheckbox.vue"
export default component.exports